// extracted by mini-css-extract-plugin
module.exports = {"author":"Item_author__1C4ah","content":"Item_content__1Q2UC","date":"Item_date__iWgJP","text":"Item_text__U892s","user":"Item_user__1EpxC"};